import { useEffect, useRef } from 'react';

export type UseOnBroadcastMessageProps<T> = {
  channelName: string;
  callback: (data: T) => void;
};

export const useOnBroadcastMessage = <T,>({ channelName, callback }: UseOnBroadcastMessageProps<T>) => {
  const channelRef = useRef<BroadcastChannel | null>(null);

  useEffect(() => {
    const channel = new BroadcastChannel(channelName);
    channelRef.current = channel;
    const handleMessage = (event: MessageEvent) => {
      callback(event.data as T);
    };

    channel.onmessage = handleMessage;

    return () => {
      channel.close();
    };
  }, [channelName, callback]);
};
